import { AbstractDocument, Identifiable, Timestampable } from '../../../abstract/Document';
import { AbstractCollection } from '../../../abstract/Collection';
import type { WithFieldValue } from 'firebase/firestore';
import { Identified, PartialMaybe, Timestamped } from '../../../abstract/_';
import type { ISupplierCalendarSchedule } from './Schedules.types';
import { Calendar } from '../Calendars';

@Identifiable
@Timestampable
export class Schedule extends AbstractDocument<ISupplierCalendarSchedule> {
  readonly collections = {};

  /**
   * Returns the parent Calendar of this Schedule
   */
  get calendar() {
    return this.reference.parent.parent!.id;
  }
}

export class Schedules extends AbstractCollection<Schedule, ISupplierCalendarSchedule> {
  static path = 'schedules';

  constructor(document: Calendar) {
    super(document.collection(Schedules.path), Schedule);
  }

  /**
   * Returns the parent Calendar of this Schedules collection
   */
  get calendar() {
    return this.reference.parent!.id;
  }

  /**
   * Creates a new calendar schedule
   *
   * @param data Object containing calendar schedule creation parameters
   */
  async create(data: WithFieldValue<PartialMaybe<ISupplierCalendarSchedule, Identified & Timestamped>>): Promise<Schedule> {
    return await this.push().create(data as ISupplierCalendarSchedule);
  }
}
